const { createSelector } = require('reselect')

const selectIcdList = state => state.icdDomain.icdList

const getIcdList = () => createSelector(
  [selectIcdList],
  cse => cse.data,
)

const getIcdListError = () => createSelector(
  [selectIcdList],
  cse => cse.error,
)

const getIcdListLoading = () => createSelector(
  [selectIcdList],
  cse => cse.loading,
)

const selectIcd = state => state.icdDomain.icd

const getIcd = () => createSelector(
  [selectIcd],
  cse => cse.data,
)

const getIcdError = () => createSelector(
  [selectIcd],
  cse => cse.error,
)

const getIcdLoading = () => createSelector(
  [selectIcd],
  cse => cse.loading,
)

const selectCreate = state => state.icdDomain.create

const getCreateIcd = () => createSelector(
  [selectCreate],
  cse => cse.data,
)

const getCreateIcdError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)

const getCreateIcdLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)
const selectUpdate = state => state.icdDomain.update

const getUpdateIcd = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)

const getUpdateIcdError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)

const getUpdateIcdLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)
const selectDelete = state => state.icdDomain.delete

const getDeleteIcd = () => createSelector(
  [selectDelete],
  cse => cse.data,
)

const getDeleteIcdError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)

const getDeleteIcdLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

module.exports = {
  getIcdList,
  getIcdListLoading,
  getIcdListError,
  getIcd,
  getIcdLoading,
  getIcdError,
  getCreateIcd,
  getCreateIcdLoading,
  getCreateIcdError,
  getUpdateIcd,
  getUpdateIcdLoading,
  getUpdateIcdError,
  getDeleteIcd,
  getDeleteIcdLoading,
  getDeleteIcdError,
}
